import React from "react";
import styled from "styled-components";
import {
  IFile,
  IMusic,
  IRelatedSectionItem,
  IUserProfile,
} from "../../../common/commonTypes";
import { routes } from "../../../routes";
import fallbackImage from "../../../assets/defaultAvatar.svg";
import { useTranslation } from "react-i18next";
import RelatedSection from "./RelatedSection";
import {
  useRelatedArtistsQuery,
  useRelatedTracksQuery,
} from "../../../queries/asset.query";

interface IProps {
  music: IMusic;
  artist: IUserProfile;
}

const RelatedWrapper = styled.div`
  position: relative;
  margin-top: 48px;
`;

const Related = ({ music, artist }: IProps) => {
  const { data: artistTracks = [], isLoading: isLoadingTracks } =
    useRelatedTracksQuery(music);
  const { data: similarArtistTracks = [], isLoading: isLoadingArtists } =
    useRelatedArtistsQuery(music);

  const { t } = useTranslation();

  const relatedTracksItems = artistTracks.map(
    (track: IMusic): IRelatedSectionItem => {
      return {
        key: track.id,
        image: track.cover,
        text: track.title,
        subtext: track.created
          ? new Date(track.created).getFullYear().toString()
          : "",
        redirectUrl: routes.marketplace.id(track.id),
      };
    }
  );

  const relatedArtistItems = similarArtistTracks.map(
    (track: IMusic): IRelatedSectionItem => {
      return {
        key: track.artist.id,
        image:
          track.artist?.profile?.image_profile ||
          ({ url: fallbackImage } as IFile),
        text: `@${track.artist?.username}`,
        subtext: `${track.artist?.profile?.views || 0} ${t("views")}`,
        redirectUrl: routes.user.url(track.artist.uri),
      };
    }
  );

  return (
    <RelatedWrapper>
      <RelatedSection
        title={`${artist?.username} ${t("tracks").toLowerCase()}`}
        items={relatedTracksItems}
        seeAllUrl={routes.user.url(artist.uri)}
        isLoading={isLoadingTracks}
        emptyTitle={t("empty-tracks")}
        emptyDescription={t("check-out-marketplace")}
      />

      {/* TODO: add seeAllUrl for search page */}
      <RelatedSection
        title={t(`similar-artists`)}
        items={relatedArtistItems}
        seeAllUrl={routes.artists}
        isLoading={isLoadingArtists}
        emptyTitle={t("empty-artists")}
        emptyDescription={t("check-out-marketplace")}
      />
    </RelatedWrapper>
  );
};

export default Related;
